import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import store from './store';
import { applyDocumentBranding } from './config/appConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

applyDocumentBranding();

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
